import { Injectable, inject } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { COOKIE_MAX_AGE_1YEAR, CookieService } from '../cookie/cookie.service';
import { FeatureToggleService } from '../feature-toggle/feature-toggle.module';
import { WindowRefService } from '../window-ref/window-ref.service';

import { FT_LOGIN_TRACKING_CONSENT } from './cookie-consent-status.tokens';
import { DidomiWin } from './cookie-consent-status.types';

const CONSENT_ANALYTICS = 'analytics_tracking_consent';
const CONSENT_ANALYTICS_COOKIE_OPTIONS = { maxAge: COOKIE_MAX_AGE_1YEAR };

@Injectable({
  providedIn: 'root'
})
export class CookieConsentStatusService {
  private readonly consentChange$: BehaviorSubject<boolean>;
  private readonly cookie = inject(CookieService);
  private readonly ftService = inject(FeatureToggleService);
  private readonly win = inject<WindowRefService<DidomiWin>>(WindowRefService).nativeWindow;

  constructor() {
    this.consentChange$ = new BehaviorSubject(this.consent);
    if (this.ftService.getToggleById(FT_LOGIN_TRACKING_CONSENT)) {
      this.createConsentWatcher();
    }
  }

  get consent(): boolean {
    return this.cookie.get(CONSENT_ANALYTICS);
  }

  get update$(): Observable<boolean> {
    return this.consentChange$.asObservable();
  }

  private createConsentWatcher(): void {
    const didomiReady = (this.win.didomiOnReady ||= []);
    didomiReady.push(client => {
      //only GDPR MOs will return values within this array, this is used to avoid setting false 'true' cookie values for non-GDPR MO's due to Didomi default functionality
      const isGDPR = client.getConfig().app.vendors.iab.restrictions.length;
      if (isGDPR) {
        const googleAnalyticsID = client.getRequiredVendorIds().find(id => id.toString().startsWith('c:googleana'));
        client.getObservableOnUserConsentStatusForVendor(googleAnalyticsID).subscribe(data => {
          if (typeof data === 'boolean') {
            this.cookie.set(CONSENT_ANALYTICS, data, CONSENT_ANALYTICS_COOKIE_OPTIONS);
            this.consentChange$.next(data);
          }
        });
      }
    });
  }
}
